import { Icon } from "@introist/react-foundation/v2";
import { TriggersListRoute } from "./routes";
import { TriggerRoute } from "./routes/TriggerRoute";

export * from "./routes";
export * from "./hooks/useTriggers";

export const TRIGGER_ROUTES = {
  triggers: {
    key: "route-triggers",
    title: "Triggers",
    icon: <Icon name="trigger" />,
    path: "/triggers",
    element: <TriggersListRoute />
  },
  triggerFolder: {
    key: "route-triggers",
    title: "Triggers",
    path: "/triggers/folder/:folderId",
    element: <TriggersListRoute />
  },
  trigger: {
    key: "route-trigger",
    title: "Trigger",
    path: "/triggers/:triggerId",
    element: <TriggerRoute />
  }
};
